import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-workreport-dialog',
  templateUrl: './delete-workreport-dialog.component.html',
  styleUrls: ['./delete-workreport-dialog.component.css']
})
export class DeleteWorkreportDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
